import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  TextField,
  FormHelperText,
  Typography,
  Avatar,
  InputAdornment,
  ClickAwayListener,
  Collapse,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect, useCallback } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import personalGoal from "../../assets/images/personal-goal.svg";
import { Navigate } from "react-router";
import { ReactComponent as TrashRed20 } from "../../assets/images/trashRed20.svg";
import { ReactComponent as Plus20 } from "../../assets/images/plus20.svg";
import ConfirmDialog from "../../components/ConfirmDialog";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as yup from 'yup';
import { useFormik } from 'formik';
import myFeedback from "../../services/myFeedback.service";
import Icon from '@mui/material/Icon';
import * as Util from "../../services/global.service";
import debounce from 'lodash.debounce';
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import Search from "@mui/icons-material/Search";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles({
  boxLeft: {
    width: "25%",
    "padding-bottom": "25px",
  },
  boxRight: {
    width: "75%",
    "padding-bottom": "25px",
  },
  input: {
    '& div > input': {
      height: '12px',
      position: "relative"
    }
    , "&.MuiFormControl-root": { "margin-top": "10px" }
  },
  styleTag: {
    '& div > .MuiOutlinedInput-root': {
      '& .MuiChip-root': {
        backgroundColor: "#EFF6F4",
        color: "#404349",
        borderRadius: "3px",
        '& .MuiChip-deleteIcon': {
          // color: "#ffffff",
        }
      },
    },
  },
  select: {
    '& div ': {
      padding: "8.5px 8.5px 8.5px 15px"
    },
  },
  selectError: {
    background: "#CC6058",
    '& div ': {
      padding: "8.5px 8.5px 8.5px 15px"
    },
    '& fieldset': {
      "border-color": "#CC6058"
    },
  },
});


const DialogRequest = (props) => {
  const { open, close, datas, openSuccessAddDialog, dataEmployee, allEmployee, dataOwner, type, selectEmployee, page, refID, typeList, dataEmpolyeeOwner } = props
  const classes = useStyles();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [question, setQuestion] = React.useState([]);
  const [loopQuestion, setLoopQuestion] = React.useState([]);
  const [statusSave, setStatusSave] = React.useState(false);
  const [discardDialog, setDiscardDialog] = React.useState(false);
  const [confirmSendDialog, setConfirmSendDialog] = React.useState(false);
  const [dataAllEmployee, setDataAllEmployee] = React.useState([]);
  const [dataAllEmployeeSendTo, setDataAllEmployeeSendTo] = React.useState([]);
  const [itemsRequestFor, setItemsRequestFor] = React.useState([]);
  const [itemsSendTo, setItemsSendTo] = React.useState([]);
  const [selectSearch, setSelectSearch] = React.useState([]);
  const [selected, setSelected] = React.useState([]);
  const [selectedSendTo, setSelectedSendTo] = React.useState([]);
  const [onSubmit, setOnSubmit] = React.useState(false);
  const validationSchema = yup.object({
    title: yup.string().required(t('admin.inputForm.msgError.code')),
    requestFor: yup.string().required(t('admin.inputForm.msgError.code'))
  });
  const formik = useFormik({
    initialValues: {
      requestFor: "",
      sendTo: [],
      title: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setConfirmSendDialog(true)
    },
  });
  useEffect(() => {
    if (open) {
      myFeedback.getListFeedbackQuestionMaster().then((rs) => {
        setQuestion(Util.formatData(rs?.data?.feedback_question, []))
        setLoopQuestion(Util.formatData(rs?.data?.feedback_question, []))
      })
      formik.resetForm()
      setStatusSave(false)
      myFeedback.getListEmployeeByReportTo({
        "code": "all"
      }).then((rs) => {
        setDataAllEmployee(Util.formatData(rs?.data?.employee))
        if (type === "self") {
          let self = Util.formatData(rs?.data?.employee, []).filter((rs) => rs?.serial === dataOwner?.serial)
          setItemsRequestFor(Util.formatData(self))
          formik.setFieldValue("requestFor", self[0].serial)
        } else {
          let self = Util.formatData(rs?.data?.employee, []).filter((rs) => rs?.serial === selectEmployee?.serial)
          setItemsRequestFor(Util.formatData(rs?.data?.employee))
          if (dataOwner?.serial !== selectEmployee?.serial) {
            formik.setFieldValue("requestFor", self[0].serial)
          }
        }
      })
      if (Util.formatData(dataOwner, false) !== false) {
        myFeedback.getListEmployeeByPermission({
          "code": "all"
        }, page === "evaluation" || page === "probation" ? dataEmpolyeeOwner?.serial : dataOwner?.serial, formik.values.requestFor).then((rs) => {
          setDataAllEmployeeSendTo(Util.formatData(rs?.data?.employee))
          setItemsSendTo(Util.formatData(rs?.data?.employee))
        })
      }
      setSelected([]);
      setSelectedSendTo([]);
      setOnSubmit(false)
    }
  }, [open]);
  useEffect(() => {
    if (Util.formatData(dataOwner, false) !== false) {
      myFeedback.getListEmployeeByPermission({
        "code": "all"
      }, page === "evaluation" || page === "probation" ? dataEmpolyeeOwner?.serial : dataOwner?.serial, formik.values.requestFor).then((rs) => {
        setDataAllEmployeeSendTo(Util.formatData(rs?.data?.employee))
        setItemsSendTo(Util.formatData(rs?.data?.employee))
      })
    }
  }, [formik.values.requestFor]);

  const handleCloseDialog = () => {
    close(false);
  };

  let addQuestion = () => {
    if (Util.formatData(question, []).length < 3) {
      let data = JSON.parse(JSON.stringify(question))
      data = [...data, { master_question_id: "", no: "", question: "" }]
      setQuestion(data)
      setLoopQuestion(data)
    }
  }

  let delQuestion = (index) => {
    if (Util.formatData(question, []).length > 1) {
      let data = JSON.parse(JSON.stringify(question))
      data.splice(index, 1);
      setLoopQuestion(data)
      setQuestion(data)
    }
  }

  let onChange = (e, index) => {
    if (Util.formatData(question, []).length > 0) {
      let data = JSON.parse(JSON.stringify(question))
      data[index].question = e.target.value
      setQuestion(data)
    }
  }

  const handleCancel = () => {
    setDiscardDialog(true)
  }
  const handleDiscardDialog = (value) => {
    setDiscardDialog(value)
  };

  const handleDiscardChangeConfirm = () => {
    setDiscardDialog(false)
    close()
  };
  const handleConfirmSendDialog = (value) => {
    setConfirmSendDialog(value)
  };

  const handleSendConfirm = () => {
    submit()
    setConfirmSendDialog(false)
    close()
  };

  const handleSubmit = () => {
    if (statusSave === false) {
      setStatusSave(true)
    }
    formik.submitForm()
    setOnSubmit(true)
  }
  const [focusSearchRequestFor, openFocusSearchRequestFor] = React.useState(false);
  const [selectSearchRequestFor, setSelectSearchRequestFor] = React.useState([]);
  const handleCloseRequestFor = (event) => {
    openFocusSearchRequestFor(false)
    if (Util.formatData(document.getElementById('searchEmployee'), false) !== false) {
      document.getElementById('searchEmployee').value = ""
    }
  };
  const handleFocusRequestFor = () => {
    setSelectSearchRequestFor([])
    openFocusSearchRequestFor(true)
  };
  const changeHandlerRequestFor = event => {
    // setQuery(event.target.value);
    dataSerachsRequestFor(event.target.value,)
  };
  const debouncedChangeHandlerRequestFor = useCallback(
    debounce(changeHandlerRequestFor, 500), console.log()
    , []);
  const onclickSelectRequestFor = (data) => {
    formik.setFieldValue("requestFor", data)
    openFocusSearchRequestFor(false)
  }
  const handleClearClick = () => {
    formik.setFieldValue("requestFor", '')
  };
  const dataSerachsRequestFor = async (data) => {
    let result = []
    let dataSerach = JSON.parse(JSON.stringify(dataAllEmployee))
    if (data !== "") {
      result = dataSerach.filter((item) => {
        return Object.keys(item).some((key) => {
          if (key === 'fullname' || key === 'code') {
            return item[key].toString().toLowerCase().indexOf(data.toString().toLowerCase()) !== -1;
          }
        });
      });
    } else {
      result = dataSerach;
    }
    await setItemsRequestFor(result)
  };
  const formikChange = (val, field) => {
    formik.setFieldValue(field, val)
    setSelected(val)
  }
  const handleSelectAllClick = (event) => {
    if (itemsRequestFor.length > 0 && selected.length !== itemsRequestFor.length) {
      const newSelecteds = dataAllEmployee.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
  };
  const handleDeSelectAllClick = (event) => {
    if (itemsRequestFor.length > 0 && selected.length > 0) {
      setSelected([]);
    }
  };

  const handleClick = (event, data) => {
    const selectedIndex = selected.indexOf(data);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, data);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };
  const isSelected = (serial) => selected.indexOf(serial) !== -1;
  const [opens, setOpens] = React.useState(false);

  const [focusSearchSendTo, openFocusSearchSendTo] = React.useState(false);
  const [selectSearchSendTo, setSelectSearchSendTo] = React.useState([]);
  const handleCloseSendTo = (event) => {
    openFocusSearchSendTo(false)
    if (Util.formatData(document.getElementById('searchEmployeeSendTo'), false) !== false) {
      document.getElementById('searchEmployeeSendTo').value = ""
    }
  };
  const handleFocusSendTo = () => {
    setSelectSearchSendTo([])
    openFocusSearchSendTo(true)
  };
  const changeHandlerSendTo = event => {
    // setQuery(event.target.value);
    dataSerachsSendTo(event.target.value,)
  };
  const debouncedChangeHandlerSendTo = useCallback(
    debounce(changeHandlerSendTo, 500), console.log()
    , []);
  const onclickSelectSendTo = (data) => {
    formik.setFieldValue("sendTo", data)
    openFocusSearchSendTo(false)
  }
  const handleClearClickSendTo = () => {
    formik.setFieldValue("sendTo", '')
  };
  const dataSerachsSendTo = async (data) => {
    let result = []
    let dataSerach = JSON.parse(JSON.stringify(dataAllEmployeeSendTo))
    if (data !== "") {
      result = dataSerach.filter((item) => {
        return Object.keys(item).some((key) => {
          if (key === 'fullname' || key === 'code') {
            return item[key].toString().toLowerCase().indexOf(data.toString().toLowerCase()) !== -1;
          }
        });
      });
    } else {
      result = dataSerach;
    }
    await setItemsSendTo(result)
  };
  const formikChangeSendTo = (val, field) => {
    formik.setFieldValue(field, val)
    setSelectedSendTo(val)
  }
  const handleSelectAllClickSendTo = (event) => {
    if (itemsSendTo.length > 0 && selectedSendTo.length !== itemsSendTo.length) {
      const newSelecteds = dataAllEmployeeSendTo.map((n) => n);
      setSelectedSendTo(newSelecteds);
      return;
    }
  };
  const handleDeSelectAllClickSendTo = (event) => {
    if (itemsSendTo.length > 0 && selectedSendTo.length > 0) {
      setSelectedSendTo([]);
    }
  };

  const handleClickSendTo = (event, data) => {
    const selectedIndexSendTo = selectedSendTo.indexOf(data);
    let newSelectedSendTo = [];

    if (selectedIndexSendTo === -1) {
      newSelectedSendTo = newSelectedSendTo.concat(selectedSendTo, data);
    } else if (selectedIndexSendTo === 0) {
      newSelectedSendTo = newSelectedSendTo.concat(selectedSendTo.slice(1));
    } else if (selectedIndexSendTo === selectedSendTo.length - 1) {
      newSelectedSendTo = newSelectedSendTo.concat(selectedSendTo.slice(0, -1));
    } else if (selectedIndexSendTo > 0) {
      newSelectedSendTo = newSelectedSendTo.concat(
        selectedSendTo.slice(0, selectedIndexSendTo),
        selectedSendTo.slice(selectedIndexSendTo + 1),
      );
    }
    setSelectedSendTo(newSelectedSendTo);
  };
  const isSelectedSendTo = (serial) => selectedSendTo.indexOf(serial) !== -1;
  const [opensSendTo, setOpensSendTo] = React.useState(false);
  const submit = () => {
    let dataSendTo = []
    for (let indexs = 0; indexs <= selectedSendTo.length - 1; indexs++) {
      dataSendTo.push(selectedSendTo[Object.keys(selectedSendTo)[indexs]].serial)
    }
    for (let idx = 0; idx <= question.length - 1; idx++) {
      question[idx].no = idx + 1
    }
    myFeedback.requestFeedback({
      "type": page === "evaluation" ? typeList : page === "probation" ? typeList : "normal",
      "ref_id": page === "evaluation" ? refID : page === "probation" ? refID : "",
      "request_for": formik.values.requestFor,
      "sent_to": dataSendTo,
      "title": formik.values.title,
      "feedback_question": page === "evaluation" || page === "probation" ? [
        {
          "no": 1,
          "master_question_id": "",
          "question": formik.values.title
        }
      ] : question
    }).then((rs) => {
      close()
      openSuccessAddDialog()
    }).catch((err) => {

    })
  }
  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md" PaperProps={{ sx: { padding: '30px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" fontWeight="600" sx={{ padding: "0 0 20px" }}>
        {t('feedback.label.requestFeedback')}
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ ".Mui-error .MuiOutlinedInput-notchedOutline": { "border-color": "#CC6058 !important" }, padding: "0", ".MuiFormHelperText-root": { color: "#CC6058 !important", } }}>
        {/* fontWeight: "500", fontSize: "14px", lineHeight: "24px", */}
        <Box >
          {page === "evaluation" || page === "probation" ?
            <Box sx={{ display: "flex", "flex-flow": "row wrap", paddingTop: "35px" }}>
              <Box className={classes.boxLeft}>
                <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
                  {typeList === 'probation' ? t('evaluation.probationName') : typeList === 'goal' ? t('evaluation.goalName') : t('evaluation.competencyName')}
                </Typography>
              </Box>
              <Box className={classes.boxRight}>
                <Typography fontSize={18} lineHeight="26.91px" color="#404349" dangerouslySetInnerHTML={{ __html: datas?.name }}></Typography>
              </Box>
              {page === "evaluation" ?
                <Box className={classes.boxLeft}>
                  <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
                    {typeList === 'probation' ? t('evaluation.probationDescription') : typeList === 'goal' ? t('evaluation.goalDescription') : t('evaluation.description')}
                  </Typography>
                </Box>
                : null
              }
              {page === "evaluation" ?
                <Box className={classes.boxRight}>
                  <Typography fontSize={18} lineHeight="26.91px" color="#404349" dangerouslySetInnerHTML={{ __html: datas?.description }}></Typography>
                </Box>
                : null
              }
            </Box>
            : null
          }
          <Box sx={{ width: "100%", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography pt="20px" color="#404349" fontWeight="500" fontSize={16} lineHeight="20px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t('feedback.label.requestFeedbackFor')}<span style={{ color: "#CC6058 ", fontWeight: "400" }}> *</span></Typography>
            <ClickAwayListener onClickAway={handleCloseRequestFor} >
              <Box sx={{ position: "relative" }}>
                <Box mt="10px" sx={{ position: "relative", "::after": { width: "100%", content: '""', height: " 100%", position: "absolute", left: 0, top: 0, }, '.MuiOutlinedInput-notchedOutline': { "border-color": onSubmit === true ? formik.touched.requestFor !== "" && formik.touched.requestFor !== undefined && formik.touched.requestFor !== null ? "#E4E7EA" : "#CC6058" : "#E4E7EA" }, ".MuiOutlinedInput-root": { borderRadius: "10px", borderColor: "#E4E7EA" } }} onClick={e => type === "self" ? null : handleFocusRequestFor(true)} >
                  <Select
                    id="workload-select"
                    inputlabelprops={{ shrink: false }}
                    variant="outlined"
                    size="small"
                    className="white-bg"
                    value={formik.values.requestFor}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    defaultValue=""
                    displayEmpty
                    placeholder={t('feedback.label.selectRequestFeedbackFor')}
                    error={Boolean(formik.touched.requestFor && formik.errors.requestFor)}
                    fullWidth
                    helperText={formik.touched.requestFor && formik.errors.requestFor}
                    name="requestFor"
                    classes={classes.select}
                    disabled={type === "self" ? true : false}
                    sx={type === "self" ? {
                      "& .MuiSelect-iconOutlined": { display: formik.values.requestFor ? 'none' : '' },
                      "&.Mui-focused .MuiIconButton-root": { color: 'primary' },
                      background: "#FAFAFA", borderRadius: "4px",
                      '&.Mui-selected': {
                        '-webkit-text-fill-color': '#404349 !important',
                        backgroundColor: "#FAFAFA !important"
                      },
                      '& .Mui-disabled': {
                        '-webkit-text-fill-color': '#404349 !important',
                        backgroundColor: "#FAFAFA !important"
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: "none"
                      },
                      '& div ': {
                        padding: "8.5px 8.5px 8.5px 15px"
                      }
                    } : {}}
                  >
                    <MenuItem disabled value="">
                      <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('feedback.label.selectRequestFeedbackFor')}</Typography>
                    </MenuItem>
                    {
                      itemsRequestFor?.length > 0 ?
                        itemsRequestFor.map(item => {
                          return (
                            <MenuItem value={item.serial} key={item.serial}>
                              {item.fullname}
                            </MenuItem>
                          )
                        })

                        : <MenuItem value="">
                          ---{t('label.notFund')}---
                        </MenuItem>
                    }
                  </Select>
                </Box>
                <Box sx={{ position: "absolute", width: "100%", zIndex: "999" }}>
                  <Collapse in={focusSearchRequestFor}>
                    <Box sx={{ width: "100%", border: "1px solid #CED4DA", background: "#FFFFFF", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", borderRadius: "8px" }} p="15px">
                      <TextField
                        id="searchEmployee"
                        fullWidth
                        placeholder={t('feedback.label.searchEmployee')}
                        size="small"
                        sx={{ background: "#fff", "input": { padding: "9px 14px" } }}
                        className="searchTextField-h40"
                        autoComplete='off'
                        onChange={debouncedChangeHandlerRequestFor}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search style={{ color: "#C4C4C4" }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box mt="15px" sx={{ maxHeight: "270px", overflowY: "overlay", }} >
                        {type === "team_member" && allEmployee.length > 0 ? allEmployee.map((rs, index) => (
                          <Box sx={{ display: "flex", flexDirection: "row", width: "100%", background: rs?.serial === formik.values.requestFor ? "rgba(93, 161, 150, 0.08)" : "", "&:hover": { "background-color": "rgba(0, 0, 0, 0.04)" }, cursor: "pointer" }} onClick={e => onclickSelectRequestFor(rs?.serial)}>
                            <Typography fontSize={16} m="10px" mr="0px" width="100%" lineHeight="24px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                              {Util.formatData(rs?.fullname, "")} <span style={{ paddingLeft: "10px", fontSize: "14px", lineHeight: "24px", fontWeight: "400", color: "#BEC2CB" }}>({Util.formatData(rs?.position, "")})</span>
                            </Typography>
                          </Box>
                        ))
                          : itemsRequestFor.length > 0 ? itemsRequestFor.map((rs, index) => (
                            <Box sx={{ display: "flex", flexDirection: "row", width: "100%", background: rs?.serial === formik.values.requestFor ? "rgba(93, 161, 150, 0.08)" : "", "&:hover": { "background-color": "rgba(0, 0, 0, 0.04)" }, cursor: "pointer" }} onClick={e => onclickSelectRequestFor(rs?.serial)}>
                              <Typography fontSize={16} m="10px" mr="0px" width="100%" lineHeight="24px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                {Util.formatData(rs?.fullname, "")} <span style={{ paddingLeft: "10px", fontSize: "14px", lineHeight: "24px", fontWeight: "400", color: "#BEC2CB" }}>({Util.formatData(rs?.position, "")})</span>
                              </Typography>
                            </Box>
                          ))
                            :
                            <Box sx={{ paddingTop: "10px", textAlign: "center" }}>
                              <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                {t('label.notFund')}
                              </Typography>
                            </Box>
                        }
                      </Box>
                    </Box>
                  </Collapse>
                </Box>
              </Box>
            </ClickAwayListener>
            {formik.touched.requestFor && formik.errors.requestFor ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
          </Box>
          <Box sx={{ width: "100%", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography pt="20px" color="#404349" fontWeight="500" fontSize={16} lineHeight="20px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t('feedback.label.sendTo')}<span style={{ color: "#CC6058 ", fontWeight: "400" }}> *</span></Typography>
            <ClickAwayListener onClickAway={handleCloseSendTo} >
              <Box sx={{ position: "relative" }}>
                <Box sx={{ position: "relative" }} onClick={e => handleFocusSendTo(true)} >
                  <Box sx={{ '.MuiOutlinedInput-notchedOutline': { "border-color": onSubmit === true ? selectedSendTo !== "" && selectedSendTo !== undefined && selectedSendTo !== null && selectedSendTo.length > 0 ? "#E4E7EA" : "#CC6058" : "#E4E7EA" }, ".MuiOutlinedInput-root": { borderRadius: "10px", padding: "8px", borderColor: "#E4E7EA" } }} >
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      size="small"
                      fullWidth
                      options={itemsSendTo}
                      disableCloseOnSelect
                      value={selectedSendTo}
                      onChange={(event, newValue) => {
                        formikChangeSendTo(newValue, "sendTo")
                      }}
                      classes={{ root: classes.styleTag }}
                      getOptionLabel={(option) => option?.fullname}
                      // renderOption={(props, option, { selected }) => (
                      //   <li {...props}>
                      //     <Checkbox
                      //       icon={icon}
                      //       checkedIcon={checkedIcon}
                      //       style={{ marginRight: 8 }}
                      //       checked={formik.values.sendTo.filter((rs) => rs?.serial === option?.serial).length > 0}
                      //     />
                      //     <span style={{ display: "flex", width: "100%", alignItems: "center" }}>
                      //       <span style={{ width: "50%", pr: "20px", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "16px" }}>{option?.fullname}</span>
                      //       <span style={{ width: "50%", pr: "20px", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "16px" }}>{option?.position}</span>
                      //     </span>
                      //     {/* {option?.value === undefined ? `${option?.name} - ${option?.description}` : option?.label} */}
                      //   </li>
                      // )}
                      renderOption={() => null}
                      open={opens}
                      onOpen={() => {
                        setOpensSendTo(false);
                      }}
                      onClose={() => openFocusSearchSendTo(false)}
                      style={{ width: "100%", color: "#404349" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={t('feedback.label.selectSendTo')}
                          InputLabelProps={{
                            ...params.inputProps,
                            shrink: true,
                          }}
                        />
                      )}
                    />
                    {onSubmit === true ? selectedSendTo !== "" && selectedSendTo !== undefined && selectedSendTo !== null && selectedSendTo.length > 0 ? <></> : (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                  </Box>
                </Box>
                <Box sx={{ position: "absolute", width: "100%", zIndex: "999" }}>
                  <Collapse in={focusSearchSendTo}>
                    <Box sx={{ width: "100%", border: "1px solid #CED4DA", background: "#FFFFFF", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", borderRadius: "8px" }} p="15px">
                      <TextField
                        id="searchEmployeeSendTo"
                        fullWidth
                        placeholder={t('feedback.label.searchEmployee')}
                        size="small"
                        sx={{ background: "#fff", "input": { padding: "9px 14px" } }}
                        className="searchTextField-h40"
                        autoComplete='off'
                        onChange={debouncedChangeHandlerSendTo}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search style={{ color: "#C4C4C4" }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Typography mt="10px" color="#888F9D" fontSize={12} lineHeight="17.94px" fontWeight={400} >{t('feedback.label.selectedItems')}: {selectedSendTo.length}</Typography>
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <Typography fontSize={14} lineHeight="24px" color={itemsSendTo.length > 0 && selectedSendTo.length === itemsSendTo.length ? "#BEC2CB" : "#5DA196"} fontWeight="400px" onClick={handleSelectAllClickSendTo} mt="10px" sx={{ cursor: itemsSendTo.length > 0 && selectedSendTo.length === itemsSendTo.length ? "default" : "pointer" }}>
                          {t('label.selectAll')}
                        </Typography>
                        <Typography fontSize={14} lineHeight="24px" color={itemsSendTo.length > 0 && selectedSendTo.length > 0 ? "#5DA196" : "#BEC2CB"} fontWeight="400px" onClick={handleDeSelectAllClickSendTo} mt="10px" ml="20px" sx={{ cursor: itemsSendTo.length > 0 && selectedSendTo.length > 0 ? "pointer" : "default" }}>
                          {t('label.deSelectAll')}
                        </Typography>
                      </Box>
                      <Box mt="15px" sx={{ maxHeight: "270px", overflowY: "overlay", }} >
                        {focusSearchSendTo && itemsSendTo.length > 0 ? itemsSendTo.map((rs, index) => {
                          const isItemSelectedSendTo = isSelectedSendTo(rs)
                          return (
                            <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
                              <Box sx={{ display: "flex", alignItems: "center" }}
                                onClick={(event) => handleClickSendTo(event, rs)}
                                role="checkbox"
                                aria-checked={isItemSelectedSendTo}
                                tabIndex={-1}
                                key={rs.serial}
                                selected={isItemSelectedSendTo}>
                                <Checkbox
                                  sx={{ padding: "0" }}
                                  // onChange={e => changeType(data?.serial)} 
                                  checked={isItemSelectedSendTo}
                                />
                              </Box>
                              <Typography fontSize={16} m="10px" mr="0px" width="100%" lineHeight="24px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                {Util.formatData(rs?.fullname, "")} <span style={{ paddingLeft: "10px", fontSize: "14px", lineHeight: "24px", fontWeight: "400", color: "#BEC2CB" }}>({Util.formatData(rs?.position, "")})</span>
                              </Typography>
                            </Box>
                          )
                        })
                          :
                          <Box sx={{ paddingTop: "10px", textAlign: "center" }}>
                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                              {t('label.notFund')}
                            </Typography>
                          </Box>
                        }
                      </Box>
                    </Box>
                  </Collapse>
                </Box>
              </Box>
            </ClickAwayListener>
            {formik.touched.sendTo && formik.errors.sendTo ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.sendTo} </FormHelperText>) : <></>}
          </Box>
          <Typography pt="20px" color="#404349" fontWeight="500" fontSize={16} lineHeight="20px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{page === "evaluation" || page === "probation" ? t('feedback.label.message') : t('feedback.label.title')}<span style={{ color: "#CC6058 ", fontWeight: "400" }}> *</span></Typography>
          <TextField
            fullWidth
            helperText={formik.touched.title && formik.errors.title}
            error={Boolean(formik.touched.title && formik.errors.title)}
            margin="normal"
            name="title"
            onChange={formik.handleChange}
            type="text"
            value={formik.values.title}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder={page === "evaluation" || page === "probation" ? t('feedback.label.fillTheMessage') : t('feedback.label.fillTheTitle')}
            classes={{ root: classes.input }}
            sx={{ ".MuiOutlinedInput-root": { color: "#404349", borderRadius: "10px" }, ".MuiOutlinedInput-notchedOutline": { border: "1px solid #E4E7EA" } }}
            inputProps={{
              sx: {
                "&::placeholder": {
                  color: "#BEC2CB",
                  fontWeight: "300",
                  opacity: "1"
                }
              }
            }}
          />
          {page === "evaluation" || page === "probation" ?
            null
            :
            <Box>
              <Typography pt="20px" color="#404349" fontWeight="500" fontSize={16} lineHeight="20px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t('feedback.label.myFeedbackQuestion')}<span style={{ color: "#CC6058 ", fontWeight: "400" }}> *</span><span style={{ color: "#BEC2CB ", fontWeight: "400", fontSize: "14px" }}> ({t('feedback.label.pleaseFillAtLeastOneQuestion')})</span></Typography>
              {Util.formatData(loopQuestion, []).length > 0 ? loopQuestion.map((rs, index) =>
                <Box display="flex" alignItems="center" pt="20px">
                  <Typography color="#5DA196" fontWeight="500" fontSize={16} lineHeight="20px" sx={{ width: "40px" }}>Q{index + 1}:</Typography>
                  <Box width="calc(100% - 80px)" sx={{ ".MuiFormControl-root": { "margin": "0" } }}>
                    <TextField
                      error={statusSave && Util.formatData(question[index] ? question[index].question : null, false) === false}
                      fullWidth
                      margin="normal"
                      name="code"
                      onChange={e => onChange(e, index)}
                      type="text"
                      value={question[index] ? question[index].question : ''}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      placeholder="Fill the feedback question"
                      classes={{ root: classes.input }}
                      sx={{ ".MuiOutlinedInput-root": { color: "#404349", borderRadius: "10px" }, ".MuiOutlinedInput-notchedOutline": { border: "1px solid #E4E7EA" } }}
                      inputProps={{
                        sx: {
                          "&::placeholder": {
                            color: "#BEC2CB",
                            fontWeight: "300",
                            opacity: "1"
                          }
                        }
                      }}
                    />
                    {statusSave && Util.formatData(question[index] ? question[index].question : null, false) === false ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                  </Box>
                  <Box sx={{ width: "40px" }} display="flex" alignItems="center" justifyContent="end">
                    <TrashRed20 style={{ cursor: question.length === 1 ? "" : "pointer", opacity: question.length === 1 ? "0.2" : "1" }} onClick={e => question.length === 1 ? null : delQuestion(index)} />
                  </Box>
                </Box>
              )
                :
                null
              }
              {Util.formatData(question, []).length < 3 ?
                <Box display="flex" alignItems="center" justifyContent="center" sx={{ cursor: "pointer", width: "max-content", m: "20px auto 10px" }} onClick={addQuestion}>
                  <Plus20 />
                  <Typography pl="10px" color="#5DA196" fontWeight="400" fontSize={14} lineHeight="20.93px" >{t('feedback.label.addAnotherQuestion')}</Typography>
                </Box>
                :
                null
              }
            </Box>
          }
          <Box pt="20px" display="flex" justifyContent="center">
            <Box mr={2} sx={{ width: "210px" }}>
              <Button color="black" variant="outlined" onClick={handleCancel} fullWidth sx={{ textTransform: "none" }}>
                {t("label.cancel")}
              </Button>
            </Box>
            <Box sx={{ width: "210px" }}>
              <Button color="primary" variant="contained" onClick={handleSubmit} fullWidth sx={{ textTransform: "none" }}>
                {t("label.send")}
              </Button>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <ConfirmDialog open={confirmSendDialog} warning={true} doConfirm={() => handleSendConfirm()} setValue={() => handleConfirmSendDialog(false)} title={t('feedback.label.confirmation')} text={t('feedback.label.areYouSureToSendRequestFeedback')} />
      <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t("corporateGoal.label.dialog.discardTitle")} text={t("corporateGoal.label.dialog.discardText")} />
    </Dialog>
  );
};
export default DialogRequest;
